// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection":"VersionDE_power-ocean-collection___hN4d"};